<app-title-section *ngIf="!embeddedInParametre"></app-title-section>

<div
  class="card p-1"
  [style.margin-left.px]="embeddedInParametre ? 0 : 15"
  [style.margin-right.px]="embeddedInParametre ? 0 : 15"
  style="min-height: 100vh;"
>
  <ul class="nav nav-tabs m-0" style="border-bottom: 1px solid #eee;">
    <li class="nav-item">
      <a
        class="nav-link"
        [routerLink]="['actif']"
        [class.active]="currentTab === 'actif'"
        (click)="filterByTab('actif')"
      >
        Actif ({{ counts.actif }})
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        [routerLink]="['archive']"
        [class.active]="currentTab === 'archive'"
        (click)="filterByTab('archive')"
      >
        Archivé ({{ counts.archive }})
      </a>
    </li>
  </ul>
  <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
    <app-lc-route-outlet></app-lc-route-outlet>
  </div>
</div>
